import { userLocationDetails } from './userLocation';

export const getCountryCode = async (userLocationData, setUserLocationDetails) => {
  let countryCode;

  try {
    if (userLocationData && userLocationData.country) {
      countryCode = userLocationData.country;
    } else {
      let host = window.location.hostname;
      if (host.includes('log2base2.com')) {
        let locationDetails = await userLocationDetails(userLocationData, setUserLocationDetails);
        countryCode = locationDetails.country;
        if (countryCode) {
          setUserLocationDetails({ ...locationDetails, from: 'locationApi' });
        }
      } else {
        setUserLocationDetails({ postal: '600032', city: 'California', country: 'US', from: 'locationApi', countryName: 'America' });
        countryCode = 'US';
      }
    }
  } catch (err) {
    if (err) {
      setUserLocationDetails({ postal: '600032', city: 'defaultUS', country: 'US', from: 'locationApi', countryName: 'America' });
      countryCode = 'US';
    }
  }

  return countryCode;
};
